import React, { Component } from 'react';
import { Banner } from './Banner';
import { Homepage } from './HomePage';
import { ActivityPage } from './ActivityPage';
import '../styles/hcHomepageStyles.css';
import englishText from '../json/english-site-text.json';
import spanishText from '../json/spanish-site-text.json';
import englishSkills from '../json/english-activity-cards.json';
import spanishSkills from '../json/spanish-activity-cards.json';

export class PageBuilder extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            language: 'English',
            siteText: englishText,
            currentPage: 'homePage',
            skills: englishSkills,
            chosenSkill: '',
        };
    }

    changeLanguage = () => {
        if (this.state.language === 'English') {
            this.setState({
                language: 'Spanish',
                siteText: spanishText,
                skills: spanishSkills, 
            });
        } else {
            this.setState({
                language: 'English',
                siteText: englishText,
                skills: englishSkills,
            });
        }
    }

    countActivities = () => {
        const skills = Object.keys(this.state.skills);
        return skills.map(skill => this.state.skills[skill].cards.length);
    }

    chooseTooltipIndex = (skillName) => {
        switch (skillName) {
        case 'Phonological Awareness':
        case 'Conciencia Fonológica':
            return 0;
        case 'Phonics':
        case 'Método Fonético':
            return 1;
        case 'Accurate and Fluent Reading':
        case 'Lectura con Fluidez y Exactitud':
            return 2;
        case 'Reading Comprehension':
        case 'Comprensión de Lectura':
            return 3;
        default:
            return -1;
        }
    }

    chooseSkill = (clickedTrackerName) => {
        this.setState({
            currentPage: 'activityPage',
            chosenSkill: clickedTrackerName,
        });
    }

    goBackHome = () => {
        this.setState({
            currentPage: 'homePage',
        });
    }

    choosePage = () => {
        if (this.state.currentPage === 'homePage') {
            return (
                <Homepage
                    pageDescription={this.state.siteText.pageDescription}
                    clickText={this.state.siteText.clickText}
                    helpURL={this.state.siteText.helpURL}
                    containerNames={this.state.siteText.containerNames}
                    toolTipText={this.state.siteText.toolTipText}
                    activitiesTxt={this.state.siteText.activityTracker}
                    activityAmounts={this.countActivities()}
                    handleSkillClick={this.chooseSkill}
                /> 
            );
        }
        const chosenSkill = this.state.skills[this.state.chosenSkill];
        const toolTipIndex = this.chooseTooltipIndex(chosenSkill.skillName);
        return (
            <ActivityPage
                skill={chosenSkill}
                handleHomeClick={this.goBackHome}
                toolTipText={this.state.siteText.toolTipText[toolTipIndex]}
                filterButtonText={this.state.siteText.filterButtonText}
                activityCardText={this.state.siteText.activityCardText}
            />
        );
    }

    render() {
        return (
            <div className="pageLayout">
                <Banner
                    handleLanguageButtonClick={this.changeLanguage}
                    languageButtonText={this.state.siteText.languageButton}
                    handleTitleClick={this.goBackHome} 
                />
                {this.choosePage()}
            </div>
        );
    }
}

export default PageBuilder;



// WEBPACK FOOTER //
// ./src/components/PageBuilder.jsx